<template>
  <div class="three-pie-charts">
    <div
      class="chart-container"
      v-for="country in countriesData"
      :key="country.name"
    >
      <div class="chart-title">{{ country.name }}消费方式占比</div>
      <div class="chart-view" :ref="`chart_${country.name}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "three-consumption-pie",
  data() {
    return {
      chartInstances: {},
      countriesData: [
        {
          name: "马来西亚",
          data: [
            { name: "线上购物", value: 35 },
            { name: "线下零售", value: 25 },
            { name: "移动支付", value: 20 },
            { name: "现金支付", value: 20 },
          ],
        },
        {
          name: "泰国",
          data: [
            { name: "线上购物", value: 28 },
            { name: "线下零售", value: 32 },
            { name: "移动支付", value: 25 },
            { name: "现金支付", value: 15 },
          ],
        },
        {
          name: "越南",
          data: [
            { name: "线上购物", value: 22 },
            { name: "线下零售", value: 38 },
            { name: "移动支付", value: 18 },
            { name: "现金支付", value: 22 },
          ],
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initCharts();
    });
  },
  methods: {
    initCharts() {
      this.countriesData.forEach((country) => {
        const chartRef = `chart_${country.name}`;
        if (this.$refs[chartRef] && this.$refs[chartRef][0]) {
          const chartInstance = this.$chart.init(this.$refs[chartRef][0]);
          this.chartInstances[country.name] = chartInstance;

          const option = {
            tooltip: {
              trigger: "item",
              formatter: "{b}: {c}%",
            },
            legend: {
              orient: "vertical",
              right: "30",
              y: "center",
              itemWidth: 12,
              itemHeight: 12,
              textStyle: {
                fontSize: 12,
                color: "#666",
              },
            },
            series: [
              {
                type: "pie",
                radius: ["80", "135"],
                avoidLabelOverlap: false,
                itemStyle: {
                  color: function({ dataIndex }) {
                    const $color = [
                      {
                        start: "rgba(65, 105, 225, 1)",
                        end: "rgba(30, 144, 255, 1)",
                      },
                      {
                        start: "rgba(50, 205, 50, 1)",
                        end: "rgba(34, 139, 34, 1)",
                      },
                      {
                        start: "rgba(255, 140, 0, 1)",
                        end: "rgba(255, 69, 0, 1)",
                      },
                      {
                        start: "rgba(148, 0, 211, 1)",
                        end: "rgba(138, 43, 226, 1)",
                      },
                    ];
                    return {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: $color[dataIndex]["start"],
                        },
                        {
                          offset: 1,
                          color: $color[dataIndex]["end"],
                        },
                      ],
                      global: false,
                    };
                  },
                },
                center: ["184", "50%"],
                label: {
                  show: false,
                  position: "center",
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: "20",
                    fontWeight: "bold",
                  },
                },
                labelLine: {
                  show: false,
                },
                data: country.data,
              },
            ],
          };

          chartInstance.setOption(option);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.three-pie-charts {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 400px;
  padding: 0;
  margin-top: 24px;

  .chart-container {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .chart-title {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #333;
      height: 30px;
      line-height: 30px;
    }

    .chart-view {
      flex: 1;
      width: 100%;
      height: calc(100% - 40px);
    }
  }
}
</style>
